import { RecoverPassword } from 'shared/auth/RecoverPassword';

export function RecoverPage() {
  return (
    <div className="login-page-step">
      <RecoverPassword />
    </div>
  );
}
